import React, { Component } from 'react';
import TorGrid from '../torgrid/torgrid';
import ChartDisplay from "./components/chartDisplay.js"
import moment from 'moment';

class StressView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hedgeData: [],
            chartData: []
        }

        this.filterData = this.filterData.bind(this);
        this.filterChartData = this.filterChartData.bind(this);
    }

    render() {
        return this.getTemplate();
    }

    filterData(colName, value) {
        var data = this.props.hedgeData;
        if (value !== 'All') {
            var arr = data.filter(function (item) {
                return item[colName] === value
            });

            this.setState({
                hedgeData: arr
            });
        } else {
            this.setState({
                hedgeData: this.props.hedgeData
            });
        }
    }

    filterChartData(colName, value, freq) {
        var data = this.props.chartData;
        var AsOfDate = moment(this.props.AsOfDate).format("YYYYMMDD");

        data = data.filter(function (item) {
            return item['for frequency'] === freq
        });

        data = data.filter(function (item) {
            return item['report date']  <= AsOfDate
        });

        if (value !== 'All') {
            var arr = data.filter(function (item) {
                return item[colName] === value
            });

            this.setState({
                chartData: arr
            });
        } else {
            this.setState({
                chartData: data
            });
        }
    }

    componentDidMount() {
        if (this.props.fund && this.props.hedgeData && this.props.chartData) {
            this.setState({
                hedgeData: [],
                chartData: []
            }, () => {
                this.filterData('Fund', this.props.fund)
                this.filterChartData('fund', this.props.fund, this.props.Frequency)
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.fund !== this.props.fund || prevProps.AsOfDate !== this.props.AsOfDate) {
            this.filterData('Fund', this.props.fund);
            this.filterChartData('fund', this.props.fund, this.props.Frequency)
        }
    }

    getTemplate() {
        if (!this.props.GroupBy || this.props.gridData.length === 0) {
            return null;
        }

        const rankingGrids = [
            { guikey: 'dealStress', title: 'Top Deal Stress', ignoreBlanks: 'asset stress pnl' },
            { guikey: 'cDRisk100', title: 'Top CD +100% Risk', ignoreBlanks: 'cswpct_100' },
            { guikey: 'cDRisk', title: 'Top CD Risk +100bp', ignoreBlanks: 'cs 100bp' },
            { guikey: 'eqRisk', title: 'Top Eq Risk -25%', ignoreBlanks: 'eq delta' },
            { guikey: 'iRRisk', title: 'Top IR Risk +100bp', ignoreBlanks: 'ir 100bp' }
        ];
        const charts = [
            { title: 'Stress Test', yKey: 'asset stress pnl', yName: 'Stress Test' },
            { title: 'CD Spread +100%', yKey: 'cswpct_100', yName: 'CD Spread +100%' },
            { title: 'CD Spread +100bp', yKey: 'cs 100bp', yName: 'CD Spread +100bp' },
            { title: 'Eq Risk -25%', yKey: 'eq -25', yName: 'Eq Risk -25%' },
            { title: 'IR +100bp', yKey: 'ir 100bp', yName: 'IR +100bp' }
        ];
        const rankingDefaultColDef = this.props.defaultColDef ?? {
            sortable: false,
            filter: false,
            floatingFilter: false,
            enableRowGroup: true,
            resizable: true,
            suppressSizeToFit: false,
            minWidth: 20,
            flex: 1
        };

        return (
            <div className="portfolio-overview portfolio-stress">
                <header className="portfolio-overview-heading">
                    <div>
                        <h2>Portfolio Stress</h2>
                    </div>
                    <span className="portfolio-overview-badge">{`${this.props.fund === 'All' ? 'All funds' : this.props.fund} · ${moment(this.props.AsOfDate).format('MMM D, YYYY')}`}</span>
                </header>

                <section className="portfolio-overview-section portfolio-overview-table-section">
                    <header className="portfolio-overview-section-header">
                        <div>
                            <h3>Stress Summary</h3>
                        </div>
                    </header>
                    <div className="portfolio-overview-grid-shell">
                        <TorGrid
                            guikey="stressSummary"
                            isHideDateInputs={true}
                            isHideSaveGridLayout={true}
                            rowData={this.props.gridData.concat(this.state.hedgeData)}
                            groupColumns={['stress type', 'Risk Type']}
                            groupDefaultExpanded={1}
                            gridIdentityColumn="positions_id"
                            toggleColumn={this.props.fund === "All"}
                            groupIncludeTotalFooter={true}
                            suppressExpandablePivotGroups={true}
                            className="dashboardgrid portfolio-overview-summary-grid"
                            rowGroupPanelShow="none"
                            enableFilter={false}
                            domLayout="autoHeight"
                            defaultColDef={this.props.defaultColDef ?? {
                                sortable: false,
                                filter: false,
                                floatingFilter: false,
                                enableRowGroup: true,
                                resizable: true,
                                suppressSizeToFit: false,
                                flex: 1
                            }}
                            sideBar="none"
                            gridTitle="Stress Summary"
                        />
                    </div>
                </section>

                <section className="portfolio-stress-ranking-grid">
                    {rankingGrids.map(grid =>
                        <article className="portfolio-overview-section portfolio-overview-ranking-card" key={grid.guikey}>
                            <header className="portfolio-overview-section-header">
                                <div>
                                    <h3>{grid.title}</h3>
                                </div>
                            </header>
                            <div className="portfolio-overview-grid-shell">
                                <TorGrid
                                    guikey={grid.guikey}
                                    isHideDateInputs={true}
                                    isHideSaveGridLayout={true}
                                    rowData={this.props.gridData}
                                    ignoreBlanks={grid.ignoreBlanks}
                                    gridIdentityColumn="positions_id"
                                    domLayout="autoHeight"
                                    suppressExpandablePivotGroups={true}
                                    className="dashboardgrid nototal portfolio-overview-top-grid portfolio-stress-ranking-table"
                                    rowGroupPanelShow="none"
                                    enableFilter={false}
                                    defaultColDef={rankingDefaultColDef}
                                    sideBar="none"
                                    gridTitle={grid.title}
                                    pagination={true}
                                />
                            </div>
                        </article>
                    )}
                </section>

                <section className="portfolio-overview-section">
                    <header className="portfolio-overview-section-header">
                        <div>
                            <h3>Historical Stress Trends</h3>
                        </div>
                    </header>
                    <div className="portfolio-chart-grid portfolio-stress-chart-grid">
                        {charts.map(chart =>
                            <article className="portfolio-chart-card" key={chart.yKey}>
                                <header><h4>{chart.title}</h4></header>
                                <div className="portfolio-chart-canvas">
                                    <ChartDisplay
                                        chartTitle=""
                                        chartType="line-grouped"
                                        xKey="format report date"
                                        yKeys={[chart.yKey]}
                                        yName={chart.yName}
                                        dataList={this.state.chartData}
                                        rotationAngle={335}
                                        corporate={true}
                                    />
                                </div>
                            </article>
                        )}
                    </div>
                </section>
            </div>
        );
    }
}
export default StressView;